import React, { createContext, useState, useContext, ReactNode } from "react";

// Define the shape of your context data
type LocationData = {
  pais: string;
  departamento: string;
  provincia: string;
  distrito: string;
};

interface LocationContextProps {
  location: LocationData;
  setLocation: (location: LocationData) => void;
}

const LocationContext = createContext<LocationContextProps | undefined>(
  undefined
);

// LocationProvider component
export const LocationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [location, setLocation] = useState<LocationData>(() => {
    const storedLocation = localStorage.getItem("location");
    return storedLocation
      ? JSON.parse(storedLocation)
      : { pais: "", departamento: "", provincia: "", distrito: "" };
  });

  const updateLocation = (newLocation: LocationData) => {
    if (
      !newLocation.pais ||
      !newLocation.departamento ||
      !newLocation.provincia ||
      !newLocation.distrito
    ) {
      throw new Error("All location fields must be provided.");
    }
    setLocation(newLocation);
    localStorage.setItem("location", JSON.stringify(newLocation));
  };

  return (
    <LocationContext.Provider value={{ location, setLocation: updateLocation }}>
      {children}
    </LocationContext.Provider>
  );
};

// Export the context for consumption
export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error("useLocation must be used within a LocationProvider");
  }
  const { location, setLocation } = context;
  return { location, setLocation };
};
